import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
}

const SEO = ({
  title = "Prime Shark | Global Startup, Investment & Business Networking Platform",
  description = "Prime Shark connects entrepreneurs, investors, mentors, and business professionals through AI-powered matchmaking. Raise funding, discover investment opportunities, buy or sell businesses, and build valuable global business connections.",
  keywords = "Prime Shark, startup funding, entrepreneurs, investors, angel investors, venture capital, startup investment, business networking, business exchange, buy business, sell business, mentors, startup ecosystem, AI matchmaking, global business platform",
  image = "https://theprimeshark.com/wp-content/uploads/2026/07/Screenshot-2026-07-06-150518.png",
  url = window.location.href,
}: SEOProps) => (
  <Helmet>
    <title>{title}</title>
    <link rel="canonical" href={url} />
    <meta name="description" content={description} />

    {keywords && (
      <meta name="keywords" content={keywords} />
    )}

    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={image} />
    <meta property="og:type" content="website" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
  </Helmet>
);

export default SEO;
